<template>
  <button type="submit" class="class">
    <i class="fa fa-circle-o-notch fa-spin" v-if="loading"></i>
    <span v-if="!loading"><slot></slot></span>
  </button>


</template>

<script>
  export default {
    name: 'loading-button',

    props: ['loading'],

  }


</script>
